// extracted by mini-css-extract-plugin
export default {"description":"description_description__Jx-oI","title":"description_title__jQYrn"};